import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserResolver } from "./shared/user-resolver.service";
import { UserDetailComponent } from "./user-detail/user-detail.component";
import { UserProfileComponent } from "./user-profile/user-profile.component";
import { UserCoursesComponent } from "./user-courses/user-courses.component";

const routes: Routes = [
  {
    path: 'users',
    component: UserDetailComponent,
    children: [
      {
        path: ':id',
        resolve: {
          course: UserResolver
        },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: UserCoursesComponent
          },
          {
            path: 'profile',
            pathMatch: 'full',
            component: UserProfileComponent
          },
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class UsersRoutingModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/users/users-routing.module.ts